import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { blogKey } from "../shared/baseUrl";

import Ai from "../assets/img/Ai.jpg";
import Banking from "../assets/img/Banking.jpg";
import Outsourcing from "../assets/img/OutSourcing.jpeg";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "../assets/css/Blogs.css";

const fallbackImages = [Ai, Banking, Outsourcing];

const Blogs = () => {
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    fetch(
      `https://www.googleapis.com/blogger/v3/blogs/2425642010638613354/posts?key=${blogKey}`,
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.items) {
          const formattedPosts = data.items.map((post, index) => ({
            ...post,
            image:
              post.images?.[0]?.url ||
              fallbackImages[index % fallbackImages.length],
          }));

          setPosts(formattedPosts);
        }
      })
      .catch((error) => console.error(error));
  }, []);

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4500,
    speed: 700,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="blogs-carousel">
      <Slider {...settings}>
        {posts.map((post, index) => (
          <div key={index} className="blog-slide">
            <a
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              className="blog-card"
            >
              <div className="blog-card-image">
                <img src={post.image} alt={post.title} />
              </div>

              <div className="blog-card-overlay" />

              <div className="blog-card-content">
                <span className="blog-tag">OUTCESS INSIGHTS</span>

                <h3>{post.title}</h3>

                <div className="blog-read-more">Read Article →</div>
              </div>
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default Blogs;
